<template>
  <div>
    <el-form label-width="180px" >
      <el-form-item label="标记为：">
        <el-select v-model="userCustomer" value-key="value" @change="changeUserCustomer" placeholder="请选择"  style="width: 10em;">
          <el-option v-for="item in userCustomerArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客服微信：" v-if="userCustomer == 1">
        <el-select v-model="userListForm.wechatId" value-key="value" placeholder="请选择"  style="width: 10em;">
          <el-option v-for="item in wechatIdArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" size="medium">关闭</el-button>
      <el-button type="primary" size="medium" @click.native="submit" v-loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import { postFormData } from '@/api/api';
import { updateUserCustomerState } from '@/api/url';
export default {
  props: {
    value: Object
  },
  data() {
    return {
      userListForm: this.value.userListForm,
      userCustomerArray: [
        {label: '未添加', value: 0},
        {label: '已添加', value: 1},
        {label: '已删除', value: 2}
      ],
      userCustomer: this.value.userListForm.customerServiceState,
      wechatIdArray: this.value.wechatIdArray,
      submitLoading: false
    }
  },
  methods: {
    cancel() {
      this.$emit('close');
    },

    changeUserCustomer() {
      if(this.userCustomer == 1) {
        this.userListForm.wechatId = this.wechatIdArray[0].value;
      } else {
        this.userListForm.wechatId = null;
      }
    },

    submit() {
      if(this.userCustomer != 1) {
        this.userListForm.wechat_id = null;
      }
      let param = {
        'id': this.userListForm.userId,
        'state': this.userCustomer,
        'wechatId': this.userListForm.wechatId
      };
      postFormData(updateUserCustomerState, param).then((data) => {
        let {code,msg} = data;
        if(code == 200){
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param);
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.submitLoading = false;
      })
          .catch(function(response){
            this.submitLoading = false;
          })
    }
  },
  mounted() {

  }
}
</script>

<style>

</style>
